<div style="margin-top: 20px; margin-left: 20px;">
  <form [formGroup]="form">
    <div class="mb-3 row" [ngClass]="{'has-error':!groupname.valid}">
      <span class="col-lg-2">Name:</span>
      <div class="col-lg-5">
        <input class="form-control" type="text" [formControl]="groupname" />
      </div>
      @if (groupname.hasError('required')) {
        <div class="col-lg-3 alert alert-danger"
          style="padding: 5px; margin-bottom: 0px;">
          Group name is required
        </div>
      }
    </div>
    <div class="mb-3 row" [ngClass]="{'has-error':!description.valid}">
      <span class="col-lg-2">Description:</span>
      <div class="col-lg-9">
        <input class="form-control" type="text" [formControl]="description" />
      </div>
    </div>
    <div class="mb-3 row" [ngClass]="{'has-error':!userClass.valid}">
      <span class="col-lg-2">Group Type:</span>
      <div class="col-lg-3">
        <select class="form-control" [formControl]="userClass">
          <option value="Administrator">Administrator</option>
          <option value="Regular">Regular</option>
          <option value="Observer">Observer</option>
        </select>
      </div>
      <user-type-info class="col-lg-1"></user-type-info>
    </div>
    <div class="mb-3 row" [ngClass]="{'has-error':!active.valid}">
      <div class="col-lg-5">
        <input type="checkbox" [formControl]="active" />
        <span class="uv-checkbox-label">Active</span>
      </div>
    </div>

    <hr />

    <div style="height: 40px;">
      <span class="label-text" style="display: inline-block; margin-left: calc(50% - 56px); padding-top: 5px;">Group Members</span>
      <button pButton icon="fa fa-plus-square-o" style="float: right;"
      label="Add Users" title="Add users to this group" class="add-button" (click)="addMemberUsers()"></button>
    </div>

    @if (hasMemberEntries) {
      <div style="padding-bottom: 10px;">
        <p-table #dt class="group-users-table" [value]="entries" [resizableColumns]="true"
          [scrollable]="true" scrollHeight="calc(280px)">
          <ng-template pTemplate="header">
            <tr>
              <th pResizableColumn pSortableColumn="username">
                Username
                <p-sortIcon field="username"></p-sortIcon>
              </th>
              <th pResizableColumn pSortableColumn="firstname">
                First Name
                <p-sortIcon field="firstname"></p-sortIcon>
              </th>
              <th pResizableColumn pSortableColumn="lastname">
                Last Name
                <p-sortIcon field="lastname"></p-sortIcon>
              </th>
              <th pResizableColumn pSortableColumn="class">
                Class
                <p-sortIcon field="class"></p-sortIcon>
              </th>
              <th pResizableColumn pSortableColumn="type">
                Type
                <p-sortIcon field="type"></p-sortIcon>
              </th>
              <th pResizableColumn pSortableColumn="active">
                Active
                <p-sortIcon field="active"></p-sortIcon>
              </th>
              <th class="uv-table-button-column-1">
              </th>
            </tr>
            <tr>
              <th>
                <input pInputText type="text" (input)="dt.filter($event.target.value, 'username', 'contains')"
                  style="width: 100%;">
                </th>
                <th>
                  <input pInputText type="text" (input)="dt.filter($event.target.value, 'firstname', 'contains')"
                    style="width: 100%;">
                  </th>
                  <th>
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'lastname', 'contains')"
                      style="width: 100%;">
                    </th>
                    <th>
                      <input pInputText type="text" (input)="dt.filter($event.target.value, 'class', 'contains')"
                        style="width: 100%;">
                      </th>
                      <th>
                        <input pInputText type="text" (input)="dt.filter($event.target.value, 'type', 'contains')"
                          style="width: 100%;">
                        </th>
                        <th>
                          <input pInputText type="text" (input)="dt.filter($event.target.value, 'active', 'contains')"
                            style="width: 100%;">
                          </th>
                          <th class="uv-table-button-column-1">
                          </th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-rowData>
                        <tr [pSelectableRow]="rowData">
                          <td>
                            <span class="uv-table-value">{{rowData.username}}</span>
                          </td>
                          <td>
                            <span class="uv-table-value">{{rowData.firstname}}</span>
                          </td>
                          <td>
                            <span class="uv-table-value">{{rowData.lastname}}</span>
                          </td>
                          <td>
                            <span class="uv-table-value">{{rowData.class}}</span>
                          </td>
                          <td>
                            <span class="uv-table-value">{{rowData.type}}</span>
                          </td>
                          <td>
                            <span class="uv-table-value">{{rowData.active}}</span>
                          </td>
                          <td class="uv-table-button-column-1">
                            <button type="button" class="btn btn-danger uv-first-table-button" title="Remove user from this group"
                              (click)="removeMemberUser(rowData.tag)">
                              <i class="pi pi-trash"></i>
                            </button>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                }

                @if (!hasMemberEntries) {
                  <div class="message-text">
                    No members have been added
                  </div>
                }
              </form>

              <user-selector [(visible)]="userSelectorVisible" header="Select users to add"
                [minUsers]="1" [maxUsers]="1000000" format="full"
                [except]="memberUserGuids" (onOk)="addSelectedMemberUsers($event)">
              </user-selector>
            </div>
